import {
    ApplicationAccessData,
    ApplicationTrustedDomainValue,
    ApplicationId,
    ApplicationIdentityDefinition,
    ApplicationThemeDefinition,
} from 'yeself-common/typings/application/Application';

import {
    GET_APPLICATION_SETTINGS_DATA,
    GET_APPLICATION_SETTINGS_DATA_ERROR,
    GET_APPLICATION_SETTINGS_DATA_SUCCESS,
    UPDATE_DETAIL_SETTINGS,
    UPDATE_DETAIL_SETTINGS_ERROR,
    FETCH_USERS_ACCESS,
    FETCH_USERS_ACCESS_SUCCESS,
    FETCH_USERS_ACCESS_ERROR,
    ACCESS_INVITE_USERS,
    ACCESS_INVITE_USERS_ERROR,
    FETCH_LANGUAGE_LIST,
    FETCH_LANGUAGE_LIST_SUCCESS,
    FETCH_LANGUAGE_LIST_ERROR,
    EXPORT_TRANSLATIONS,
    EXPORT_TRANSLATIONS_ERROR,
    IMPORT_TRANSLATIONS,
    IMPORT_TRANSLATIONS_ERROR,
    EXPORT_ADD_ON_TRANSLATIONS,
    EXPORT_ADD_ON_TRANSLATIONS_ERROR,
    IMPORT_ADD_ON_TRANSLATIONS,
    IMPORT_ADD_ON_TRANSLATIONS_ERROR,
    FETCH_ADD_ON_OAUTH_AUTHORIZATION_CODE_URL,
    DELETE_ADDON,
    DELETE_ADDON_SUCCESS,
    DELETE_ADDON_ERROR,
    POST_ADD_ON,
    POST_ADD_ON_SUCCESS,
    POST_ADD_ON_ERROR,
    UPDATE_ADD_ON,
    UPDATE_ADD_ON_SUCCESS,
    UPDATE_ADD_ON_ERROR,
    ADD_ON_OAUTH_AUTHORIZATION_CODE_URL_SUCCESS,
    OPEN_ADDON_DETAIL_DRAWER,
    CLOSE_ADDON_DETAIL_DRAWER,
    LOAD_ARTICLES_PICKER_SCRIPT,
    LOAD_ARTICLES_PICKER_SCRIPT_SUCCESS,
    RESET_FACTS_APPLICATION,
    RESET_FACTS_APPLICATION_ERROR,
    RESET_FACTS_FOR_USER,
    RESET_FACTS_FOR_USER_ERROR,
    POST_GUIDE_GENERATION,
    POST_GUIDE_GENERATION_SUCCESS,
    POST_GUIDE_GENERATION_ERROR,
    POST_DUPLICATE_APPLICATION,
    POST_DUPLICATE_APPLICATION_SUCCESS,
    POST_DUPLICATE_APPLICATION_ERROR,
} from './SettingsConstants';

import {
    SettingsActionTypes,
    UPDATE_APPLICATION_ACCESS_REQUEST,
    UPDATE_APPLICATION_ACCESS_SUCCESS,
    UPDATE_APPLICATION_ACCESS_FAIL,
    UPDATE_APPLICATION_ACCESS_IDLE,
    FETCH_INSTALLED_LIST_ADDONS_FAIL,
    FETCH_INSTALLED_LIST_ADDONS_REQUEST,
    FETCH_INSTALLED_LIST_ADDONS_IDLE,
    FETCH_INSTALLED_LIST_ADDONS_SUCCESS,
    FETCH_AVAILABLE_LIST_ADDONS_FAIL,
    FETCH_AVAILABLE_LIST_ADDONS_REQUEST,
    FETCH_AVAILABLE_LIST_ADDONS_IDLE,
    FETCH_AVAILABLE_LIST_ADDONS_SUCCESS,
    UPDATE_APPLICATION_IDENTITY_REQUEST,
    UPDATE_APPLICATION_IDENTITY_SUCCESS,
    UPDATE_APPLICATION_IDENTITY_FAIL,
    UPDATE_APPLICATION_IDENTITY_IDLE,
    UPDATE_APPLICATION_EXTENSION_URLS_REQUEST,
    UPDATE_APPLICATION_EXTENSION_URLS_SUCCESS,
    UPDATE_APPLICATION_EXTENSION_URLS_FAIL,
    UPDATE_APPLICATION_TRUSTED_DOMAINS_REQUEST,
    UPDATE_APPLICATION_TRUSTED_DOMAINS_SUCCESS,
    UPDATE_APPLICATION_TRUSTED_DOMAINS_FAIL,
    UPDATE_APPLICATION_TRUSTED_DOMAINS_IDLE,
    UPDATE_APPLICATION_THEME_REQUEST,
    UPDATE_APPLICATION_THEME_SUCCESS,
    UPDATE_APPLICATION_THEME_FAIL,
    UPDATE_APPLICATION_THEME_IDLE,
    ROLLOUT_POLICIES_BY_MY_ORGANIZATIONS_ERROR,
    ROLLOUT_POLICIES_BY_MY_ORGANIZATIONS_REQUEST,
    ROLLOUT_POLICIES_BY_MY_ORGANIZATIONS_SUCCESS,
    ROLLOUT_POLICIES_BY_SPACE_ID_ERROR,
    ROLLOUT_POLICIES_BY_SPACE_ID_REQUEST,
    ROLLOUT_POLICIES_BY_SPACE_ID_SUCCESS,
    AvailableRolloutPolicy,
    RolloutPolicyWithUrl,
    ExtensionUrl,
} from './types';

export const openAddonDetailDrawer = (addonInstanceSystemKey) => ({
    type: OPEN_ADDON_DETAIL_DRAWER,
    payload: addonInstanceSystemKey,
});

export const closeAddonDetailDrawer = () => ({
    type: CLOSE_ADDON_DETAIL_DRAWER,
});

export const getApplicationSettingsData = (appId) => ({
    type: GET_APPLICATION_SETTINGS_DATA,
    payload: appId,
});

export const getApplicationSettingsDataSuccess = (data) => ({
    type: GET_APPLICATION_SETTINGS_DATA_SUCCESS,
    payload: { data },
});

export const getApplicationSettingsDataError = () => ({
    type: GET_APPLICATION_SETTINGS_DATA_ERROR,
});

export const updateDetailSettings = (payload, message) => ({
    type: UPDATE_DETAIL_SETTINGS,
    payload,
    message,
});

export const updateDetailSettingsError = () => ({
    type: UPDATE_DETAIL_SETTINGS_ERROR,
});

// LANGUAGE
export const fetchLanguageList = (appId) => ({
    type: FETCH_LANGUAGE_LIST,
    payload: appId,
});

export const fetchLanguageListSuccess = (payload) => ({
    type: FETCH_LANGUAGE_LIST_SUCCESS,
    payload,
});

export const fetchLanguageListError = () => ({
    type: FETCH_LANGUAGE_LIST_ERROR,
});
// TRANSLATIONS
export const exportAddOnTranslations = (addon, message) => ({
    type: EXPORT_ADD_ON_TRANSLATIONS,
    payload: addon,
    message,
});

export const exportAddOnTranslationsError = () => ({
    type: EXPORT_ADD_ON_TRANSLATIONS_ERROR,
});

export const exportTranslations = (message, format) => ({
    type: EXPORT_TRANSLATIONS,
    message,
    format,
});

export const exportTranslationsError = () => ({
    type: EXPORT_TRANSLATIONS_ERROR,
});

export const importTranslations = (file, message) => ({
    type: IMPORT_TRANSLATIONS,
    payload: { file },
    message,
});

export const importTranslationsError = () => ({
    type: IMPORT_TRANSLATIONS_ERROR,
});

export const importAddOnTranslations = (addon, file, message) => ({
    type: IMPORT_ADD_ON_TRANSLATIONS,
    payload: { addon, file },
    message,
});

export const importAddOnTranslationsError = () => ({
    type: IMPORT_ADD_ON_TRANSLATIONS_ERROR,
});

export const fetchUsersAccess = (message) => ({
    type: FETCH_USERS_ACCESS,
    message,
});

export const fetchUsersAccessData = (payload) => ({
    type: FETCH_USERS_ACCESS_SUCCESS,
    payload,
});

export const fetchUsersAccessError = () => ({
    type: FETCH_USERS_ACCESS_ERROR,
});

export const onInviteNewUsersInAccess = (payload, message) => ({
    type: ACCESS_INVITE_USERS,
    payload,
    message,
});

export const inviteNewUsersInAccessError = () => ({
    type: ACCESS_INVITE_USERS_ERROR,
});

export const updateApplicationAccessRequest = (
    applicationId: ApplicationId,
    access: ApplicationAccessData
): SettingsActionTypes => ({
    type: UPDATE_APPLICATION_ACCESS_REQUEST,
    payload: { applicationId, access },
});

export const updateApplicationAccessSuccess = (
    applicationId: ApplicationId,
    access: ApplicationAccessData
): SettingsActionTypes => ({
    type: UPDATE_APPLICATION_ACCESS_SUCCESS,
    payload: { applicationId, access },
});

export const updateApplicationAccessFail = (): SettingsActionTypes => ({
    type: UPDATE_APPLICATION_ACCESS_FAIL,
});

export const updateApplicationAccessIdle = (): SettingsActionTypes => ({
    type: UPDATE_APPLICATION_ACCESS_IDLE,
});

export const updateApplicationIdentityRequest = (
    applicationId: ApplicationId,
    identity: ApplicationIdentityDefinition
): SettingsActionTypes => ({
    type: UPDATE_APPLICATION_IDENTITY_REQUEST,
    payload: { applicationId, identity },
});

export const updateApplicationIdentitySuccess = (
    applicationId: ApplicationId,
    identity: ApplicationIdentityDefinition
): SettingsActionTypes => ({
    type: UPDATE_APPLICATION_IDENTITY_SUCCESS,
    payload: { applicationId, identity },
});

export const updateApplicationIdentityFail = (): SettingsActionTypes => ({
    type: UPDATE_APPLICATION_IDENTITY_FAIL,
});

export const updateApplicationIdentityIdle = (): SettingsActionTypes => ({
    type: UPDATE_APPLICATION_IDENTITY_IDLE,
});

export const updateApplicationThemeRequest = (
    applicationId: ApplicationId,
    theme: ApplicationThemeDefinition
): SettingsActionTypes => ({
    type: UPDATE_APPLICATION_THEME_REQUEST,
    payload: { applicationId, theme },
});

export const updateApplicationThemeSuccess = (
    applicationId: ApplicationId,
    theme: ApplicationThemeDefinition
): SettingsActionTypes => ({
    type: UPDATE_APPLICATION_THEME_SUCCESS,
    payload: { applicationId, theme },
});

export const updateApplicationThemeFail = (): SettingsActionTypes => ({
    type: UPDATE_APPLICATION_THEME_FAIL,
});

export const updateApplicationThemeIdle = (): SettingsActionTypes => ({
    type: UPDATE_APPLICATION_THEME_IDLE,
});

export const updateApplicationExtensionUrlsRequest = (
    applicationId: ApplicationId,
    extensionUrls: ExtensionUrl[]
): SettingsActionTypes => ({
    type: UPDATE_APPLICATION_EXTENSION_URLS_REQUEST,
    payload: { applicationId, extensionUrls },
});

export const updateApplicationExtensionUrlsSuccess = (
    applicationId: ApplicationId,
    extensionUrls: ExtensionUrl[]
): SettingsActionTypes => ({
    type: UPDATE_APPLICATION_EXTENSION_URLS_SUCCESS,
    payload: { applicationId, extensionUrls },
});

export const updateApplicationExtensionUrlsFail = (): SettingsActionTypes => ({
    type: UPDATE_APPLICATION_EXTENSION_URLS_FAIL,
});

export const updateApplicationTrustedDomainsRequest = (
    applicationId: ApplicationId,
    trustedDomains: ApplicationTrustedDomainValue[]
): SettingsActionTypes => ({
    type: UPDATE_APPLICATION_TRUSTED_DOMAINS_REQUEST,
    payload: { applicationId, trustedDomains },
});

export const updateApplicationTrustedDomainsSuccess = (
    applicationId: ApplicationId,
    trustedDomains: ApplicationTrustedDomainValue[]
): SettingsActionTypes => ({
    type: UPDATE_APPLICATION_TRUSTED_DOMAINS_SUCCESS,
    payload: { applicationId, trustedDomains },
});

export const updateApplicationTrustedDomainsFail = (): SettingsActionTypes => ({
    type: UPDATE_APPLICATION_TRUSTED_DOMAINS_FAIL,
});

export const updateApplicationTrustedDomainsIdle = (): SettingsActionTypes => ({
    type: UPDATE_APPLICATION_TRUSTED_DOMAINS_IDLE,
});

export const fetchInstalledListAddonsRequest = (applicationId: ApplicationId): SettingsActionTypes => ({
    type: FETCH_INSTALLED_LIST_ADDONS_REQUEST,
    payload: applicationId,
});

export const fetchInstalledListAddonsSuccess = (
    data: Record<string, unknown>[]
): SettingsActionTypes => ({
    type: FETCH_INSTALLED_LIST_ADDONS_SUCCESS,
    payload: data,
});

export const fetchInstalledListAddonsFail = (reason: Record<string, unknown>): SettingsActionTypes => ({
    type: FETCH_INSTALLED_LIST_ADDONS_FAIL,
    payload: reason,
});

export const fetchInstalledListAddonsIdle = (): SettingsActionTypes => ({
    type: FETCH_INSTALLED_LIST_ADDONS_IDLE,
});

export const fetchAvailableListAddonsRequest = (applicationId: ApplicationId): SettingsActionTypes => ({
    type: FETCH_AVAILABLE_LIST_ADDONS_REQUEST,
    payload: applicationId,
});

export const fetchAvailableListAddonsSuccess = (
    data: Record<string, unknown>[]
): SettingsActionTypes => ({
    type: FETCH_AVAILABLE_LIST_ADDONS_SUCCESS,
    payload: data,
});

export const fetchAvailableListAddonsFail = (reason: Record<string, unknown>): SettingsActionTypes => ({
    type: FETCH_AVAILABLE_LIST_ADDONS_FAIL,
    payload: reason,
});

export const fetchAvailableListAddonsIdle = (): SettingsActionTypes => ({
    type: FETCH_AVAILABLE_LIST_ADDONS_IDLE,
});

export const fetchAddOnOauthAuthorizationCodeUrl = (
    applicationId,
    addonSystemKey,
    addonInstanceSystemKey
) => ({
    type: FETCH_ADD_ON_OAUTH_AUTHORIZATION_CODE_URL,
    payload: {
        applicationId,
        addonSystemKey,
        addonInstanceSystemKey,
    },
});

export const addOnOauthAuthorizationCodeUrlSuccess = (addonInstanceSystemKey, url, redirectUri) => ({
    type: ADD_ON_OAUTH_AUTHORIZATION_CODE_URL_SUCCESS,
    payload: {
        addonInstanceSystemKey,
        url,
        redirectUri,
    },
});

// Delete Add-on
export const deleteAddOn = (payload) => ({
    type: DELETE_ADDON,
    payload,
});

export const deleteAddOnSuccess = (payload) => ({
    type: DELETE_ADDON_SUCCESS,
    payload,
});

export const deleteAddOnError = () => ({
    type: DELETE_ADDON_ERROR,
});

// Create Add-on
export const createNewAddOn = (payload, message) => ({
    type: POST_ADD_ON,
    payload,
    message,
});

export const createNewAddOnSuccess = (payload) => ({
    type: POST_ADD_ON_SUCCESS,
    payload,
});

export const createNewAddOnError = () => ({
    type: POST_ADD_ON_ERROR,
});

// Update Add-on
export const updateAddOn = (addOnId, data, message) => ({
    type: UPDATE_ADD_ON,
    payload: { addOnId, data, message },
});

export const updateAddonSuccess = (addOnId, data) => ({
    type: UPDATE_ADD_ON_SUCCESS,
    payload: { addOnId, data },
});

export const updateAddonError = () => ({
    type: UPDATE_ADD_ON_ERROR,
});

export const loadArticlesPickerScript = () => ({
    type: LOAD_ARTICLES_PICKER_SCRIPT,
});

export const loadArticlesPickerScriptRequestSuccess = (payload) => ({
    type: LOAD_ARTICLES_PICKER_SCRIPT_SUCCESS,
    payload,
});

// Audience
export const resetFactsApplication = (appId, message) => ({
    type: RESET_FACTS_APPLICATION,
    payload: appId,
    message,
});

export const resetFactsApplicationError = () => ({
    type: RESET_FACTS_APPLICATION_ERROR,
});

export const resetFactsForUser = (appId, userId, message) => ({
    type: RESET_FACTS_FOR_USER,
    payload: { appId, userId },
    message,
});

export const resetFactsForUserError = () => ({
    type: RESET_FACTS_FOR_USER_ERROR,
});

// Guide generation
export const generateGuide = (payload, message) => ({
    type: POST_GUIDE_GENERATION,
    payload,
    message,
});

export const generateGuideSuccess = (payload) => ({
    type: POST_GUIDE_GENERATION_SUCCESS,
    payload,
});

export const generateGuideError = () => ({
    type: POST_GUIDE_GENERATION_ERROR,
});

export const duplicateApplication = (sourceApplicationId, message) => ({
    type: POST_DUPLICATE_APPLICATION,
    payload: { sourceApplicationId },
    message,
});

export const duplicateApplicationSuccess = (payload, sourceApplicationId) => ({
    type: POST_DUPLICATE_APPLICATION_SUCCESS,
    payload: { data: payload, sourceApplicationId },
});

export const duplicateApplicationError = () => ({
    type: POST_DUPLICATE_APPLICATION_ERROR,
});

export const rolloutPoliciesByMyOrganizationsRequest = (): SettingsActionTypes => ({
    type: ROLLOUT_POLICIES_BY_MY_ORGANIZATIONS_REQUEST,
});

export const rolloutPoliciesByMyOrganizationsSuccess = (
    rolloutPolicies: AvailableRolloutPolicy[]
): SettingsActionTypes => ({
    type: ROLLOUT_POLICIES_BY_MY_ORGANIZATIONS_SUCCESS,
    payload: rolloutPolicies,
});

export const rolloutPoliciesByMyOrganizationsError = (
    reason: Record<string, unknown>
): SettingsActionTypes => ({
    type: ROLLOUT_POLICIES_BY_MY_ORGANIZATIONS_ERROR,
    payload: reason,
});

export const rolloutPoliciesBySpaceIdRequest = (): SettingsActionTypes => ({
    type: ROLLOUT_POLICIES_BY_SPACE_ID_REQUEST,
});

export const rolloutPoliciesBySpaceIdSuccess = (
    rolloutPolicies: RolloutPolicyWithUrl[]
): SettingsActionTypes => ({
    type: ROLLOUT_POLICIES_BY_SPACE_ID_SUCCESS,
    payload: rolloutPolicies,
});

export const rolloutPoliciesBySpaceIdError = (reason: Record<string, unknown>): SettingsActionTypes => ({
    type: ROLLOUT_POLICIES_BY_SPACE_ID_ERROR,
    payload: reason,
});
